import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IApiresponse, IApiRequest, ApiRequest, DashboardCountEnum } from 'src/app/_models';
import { environment } from 'src/environments/environment';
import { IExpenseApprovalResponse, ISubmitApproverAction, RequestApproveExpenses, ResponseApproveExpenses } from 'src/app/_models/twostepapproval/submitapproveraction';
import { setHeader } from 'src/app/_helpers/setRequestHeader';
import { ClaimsHeaderService } from 'src/app/shared/claimsHeader/claims-header.service';
import { DashboardService } from '..';
import { ClaimsService } from '../common/claims.service';
import { Claims } from '../../_models/common/claims';
import { ApprovalSummary } from 'src/app/_models/Dashboard/approval-summary';
import { DashboardDataRequest, RespGetVendorActionableCount } from '../../_models/Dashboard/dashboardAPI';
import { VendorDashboardDataRequest } from '../../_models/vendor/vendor.model';

@Injectable({
  providedIn: 'root'
})
export class SubmitapproveractionService {

  expenseListFilterCacheKey: any = "ExpenseApprovalListFilters";
  expenseDetailUrl: string;
  expenseID: number;
  claims: Claims;
  constructor(private http: HttpClient, private header: setHeader, private claimsHeaderService: ClaimsHeaderService
    , private dashboardService: DashboardService, private claimsService: ClaimsService) {
    this.claimsService.currentClaims.subscribe(claims => {
      this.claims = claims;
    });
  }

  setExpenseListFilters(appliedFilters) {
    if (appliedFilters) {
      sessionStorage.setItem(this.expenseListFilterCacheKey, JSON.stringify(appliedFilters));
    }
    else {
      sessionStorage.removeItem(this.expenseListFilterCacheKey);
    }
  }

  getExpenseListFilters() {
    var filters = sessionStorage.getItem(this.expenseListFilterCacheKey);
    if (filters) {
      return JSON.parse(filters);
    }
    return null;
  }

  bulkApproveExpenses(request: RequestApproveExpenses): Observable<IApiresponse<ResponseApproveExpenses>> {
    const approveRequest = new ApiRequest<RequestApproveExpenses>("", 1, "");
    approveRequest.requestInfo = request;
    return this.http.post<any>(`${environment.expenseApiUrl}BulkApproveExpenses`, approveRequest,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }

  SoloCheckFunctionPurchased(): Observable<IApiresponse<boolean>> {
    let params = new HttpParams();
    params = params.append("functionId", '20');
    let url = `${environment.billingApiUrl}CheckFunctionPurchased`;
    return this.http.get<IApiresponse<boolean>>(url, { params: params, headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }

  SoloCheckFunctionPurchasedMileage(): Observable<IApiresponse<boolean>> {
    let params = new HttpParams();
    params = params.append("functionId", '23');
    let url = `${environment.billingApiUrl}CheckFunctionPurchased`;
    return this.http.get<IApiresponse<boolean>>(url, { params: params, headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }
  SubmitApproverAction(requestinfo: IApiRequest<ISubmitApproverAction>): Observable<IApiresponse<IExpenseApprovalResponse>> {
    let body = JSON.stringify(requestinfo);
    return this.http.post<IApiresponse<IExpenseApprovalResponse>>(`${environment.expenseApiUrl}SubmitApproverAction`, body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }
  getActionableFMCount(requestCountType: number) {
    let request = new DashboardDataRequest();
    request.loginId = this.claims.LoginId;
    request.userId = this.claims.UserId;
    request.orgId = this.claims.OrgId;
    request.requestCountType = requestCountType;
    this.dashboardService.SoloGetActionableRecordForDashboard(request)
      .subscribe(fmcount => {
        const approvalSummary: ApprovalSummary = fmcount.responseInfo["approvalSummary"];
        if (requestCountType == DashboardCountEnum.Approver_Count) {
          this.claims.pendingCountNRApprover = approvalSummary.nrCountForFM;
          this.claims.pendingCountFCApprover = approvalSummary.fcCountForApprover;
          this.claims.pendingExpenseCountApprover = approvalSummary.pendingExpensesWithApprover;
          this.claims.pendingCountPreApproval = approvalSummary.pendingPreApprovalsWithApprover;
          this.claims.pendingAdvancesForApproval = approvalSummary.pendingCountAdvanceApproval;          
        }
        this.claims.pendingForFinanceApproval = approvalSummary.pendingCountFinanceApproval;
        this.claims.pendingExpensesForPayment = approvalSummary.pendingCountFinancePayment;
        this.claims.pendingCountNRFinanceApproval = approvalSummary.pendingCountNRFinanceApproval;
        this.claims.pendingCountFCFinanceApproval =  approvalSummary.pendingCountFCFinanceApproval;
        this.claims.pendingAdvanceForFinanceApproval = approvalSummary.pendingCountAdvanceFinanceApproval;
        this.claims.pendingAdvancesForPayment = approvalSummary.pendingCountAdvancePay;        
        this.claimsService.updateClaims(this.claims);
      });
  }

  fnGetSoloActionableVendorCountData(){
    let request = new VendorDashboardDataRequest();
    request.loginId = this.claims.LoginId;
    request.userId = this.claims.UserId;
    request.orgId = this.claims.OrgId;
    request.requestCountType = DashboardCountEnum.Dashboard_Count;
    this.dashboardService
      .SoloGetActionableRecordForVendorDashboard(request)
      .subscribe((resp:IApiresponse<RespGetVendorActionableCount>) => {
        if (resp && resp.responseInfo) {
          let vendordashboardcount = resp.responseInfo;
          //this.claims.CreatedReqcount = vendordashboardcount.createdReqcount;
        this.claims.ReqForReviewCount = vendordashboardcount.reqForReviewCount;
        this.claims.ReqForFinanceReviewCount = vendordashboardcount.reqForFinanceReviewCount;
        this.claims.ListOfDraftOrderCount = vendordashboardcount.listOfDraftOrderCount;
        this.claims.DraftPurchaseOrderCount = vendordashboardcount.draftPurchaseOrderCount;
        this.claims.FinalPurchaseOrderCount = vendordashboardcount.finalPurchaseOrderCount;
        this.claims.ReportAnalysisCount = vendordashboardcount.reportAnalysisCount;
        this.claims.InvoiceForFinanceReviewCount = vendordashboardcount.invoiceForFinanceReviewCount;
        //this.claims.InvoiceForPayCount = vendordashboardcount.invoiceForPayCount;
        this.claims.UnallocatedInvoiceCount = vendordashboardcount.unallocatedInvoiceCount;
        this.claims.PartiallyAllocatedInvoiceCount = vendordashboardcount.partiallyAllocatedInvoiceCount;
        this.claims.FullyAllocatedInvoiceCount = vendordashboardcount.fullyAllocatedInvoiceCount;
        this.claims.RejectedReqCount = vendordashboardcount.rejectedReqCount;
        this.claims.RejectedInvoiceCount = vendordashboardcount.rejectedInvoiceCount;
        this.claims.IncompleteInvoiceCount = vendordashboardcount.incompleteInvoiceCount;
        localStorage.setItem("claims", JSON.stringify(this.claims));
          //this.claimsService.updateClaims(this.claims);
        }
        
        
      });
  }


}
